import { Box, DialogContent } from '@mui/material'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import SignatureCanvas from 'react-signature-canvas'

import DialogLayout from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.component'
import { SIZES } from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

import useSignatureCaptureStore from '../../../../../stores/signature-capture.store'
import { styles } from './add-signature-dialog.styles'

const AddSignatureDialog = ({ onSaveSignature }) => {
  const { t } = useTranslation('checkout')
  const { popDialog } = useDialog()
  const setCapturedSignature = useSignatureCaptureStore((state) => state.setCapturedSignature)
  const signatureRef = useRef()
  const containerRef = useRef()

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const syncCanvasSize = () => {
      const canvas = signatureRef.current?.getCanvas()
      if (!canvas) return

      const { offsetWidth, offsetHeight } = container
      if (canvas.width === offsetWidth && canvas.height === offsetHeight) return

      const data = signatureRef.current.isEmpty() ? null : signatureRef.current.toDataURL()
      canvas.width = offsetWidth
      canvas.height = offsetHeight
      if (data) signatureRef.current.fromDataURL(data)
    }

    const observer = new ResizeObserver(syncCanvasSize)
    observer.observe(container)
    syncCanvasSize()

    return () => observer.disconnect()
  }, [])

  const handleSecondaryAction = () => {
    signatureRef.current.clear()
  }

  const handlePrimaryAction = () => {
    const base64Signature = signatureRef.current.toDataURL()
    setCapturedSignature(base64Signature)
    onSaveSignature?.(base64Signature)
    popDialog()
  }

  return (
    <DialogLayout
      size={SIZES.XS}
      title={t('membershipAgreementsStep.addSignature')}
      primaryAction={{
        label: t('membershipAgreementsStep.saveSignature'),
        action: handlePrimaryAction,
        props: {
          type: 'button',
        },
      }}
      secondaryAction={{
        label: t('common:clear'),
        action: handleSecondaryAction,
        props: {
          type: 'button',
        },
      }}
    >
      <DialogContent sx={styles.signatureDialogContent}>
        <Box ref={containerRef} sx={styles.signatureContainer}>
          <SignatureCanvas
            penColor="#000000"
            canvasProps={{ style: styles.signatureCanvas }}
            ref={signatureRef}
          />
        </Box>
      </DialogContent>
    </DialogLayout>
  )
}

AddSignatureDialog.propTypes = {
  onSaveSignature: PropTypes.func,
}

export default AddSignatureDialog
